import React, { useEffect, useState } from "react";
import axios from "axios";
import Base from "../components/Baseurl.json";
import "../home.scss";

const APPID = "dj00aiZpPW1mWDJ0c0hWWWZIaSZzPWNvbnN1bWVyc2VjcmV0Jng9Mjg-";

export const Fetch = (code) => {
  console.log(code.code);
  const [posts, setPosts] = useState([]);
  const [isHit, setHit] = useState(false);
  var hitslist;
  var name;
  var genre;
  var image;


  const fetchData = async () => {
    const url =
      "https://proxy.pigeons.house/https://shopping.yahooapis.jp/ShoppingWebService/V3/itemSearch?appid=" +
      APPID +
      "&jan_code=" +
      code.code +
      "&results=1";
      axios
      .get(url)
      .then((res) => {
        //alert(res)
        //alert("せいこうしました")
        setPosts(res.data);
        setHit(true);
      })
      .catch(function (error) {
        alert(error)
        setHit(false);
        console.log(error);
      });
  };

  useEffect(()=>{fetchData()},[]);

  if (!posts) return null;
  hitslist = posts["hits"];
  if (isHit) {
    if (!posts) {
      name = "notfound";
      genre = "notfound";
    } else {
      const list0 = hitslist[0];
      name = list0.name;
      genre = list0.genreCategory.name;
      image = list0.image.medium;
      console.log(image);
      console.log(list0.name);
    }
  } else {
    genre = "notfound";
    image = "https://1.bp.blogspot.com/-ezrLFVDoMhg/Xlyf7yQWzaI/AAAAAAABXrA/utIBXYJDiPYJ4hMzRXrZSHrcZ11sW2PiACNcBGAsYHQ/s1600/no_image_yoko.jpg";
  }
  const Form = () => {
    var today = new Date();
    var Month = "";
    if (today.getMonth() + 1 < 10) {
      Month = "0" + (today.getMonth() + 1);
    } else {
      Month = "" + (today.getMonth() + 1);
    }

    var token = document.cookie;
    var nowdate = today.getFullYear() + "-" + Month + "-" + today.getDate();
    const [gram, setgram] = useState(0);
    const [limit, setLimit] = useState(nowdate);

    const headers = {
      "jwt-token": token,
    };

    const PushData = async () => {
      const genreurl = encodeURI(genre);
      const imageurl2 = encodeURI(image);
      const gramurl = encodeURI(gram);
      const limiturl = encodeURI(limit);

      const url =
        Base.Baseurl +
        "/api/v1/foods?name=" +
        genreurl +
        "&quantity=" +
        gramurl +
        "&limit_at=" +
        limiturl +
        "&thumbnail_url=" +
        imageurl2;
      console.log(url);

      await axios.post(url, {}, { headers }).catch((err) => {
        return null;
      });
    };

    function Push() {
      if (gram === 0) {
        console.log("error");
      } else {
        PushData();
      }
    }

    return (
      <div>
        <label>量:</label>
        <input className="w=1/3 py-2border-b focus:outline-none focus:border-b-2 focus:border-indigo-500 placeholder-gray-500 placeholder-opacity-50"
          type="number"
          value={gram}
          placeholder="量(g)を入力"
          onChange={(event) => setgram(event.target.value)}
        />
        

        <br></br>
        賞味期限<br></br>
        <input
          type="date"
          value={limit}
          onChange={(event) => setLimit(event.target.value)}
        ></input>
        <br></br>
        <button className="shadow-lg bg-rose-500 shadow-rose-500/50 text-white rounded px-2 py-1"
          onClick={() => {
            Push();

          }}
        >
          送信
        </button>
      </div>
    );
  };

  return (
    <div>
      <p style={{ textAlign: "center" }}>
        <br></br>
        {genre}
        <br></br>
        <img
          src={image}
          alt="img"
          style={{
            margin: "auto",
            width: "50%",
          }}
        ></img>
        <br></br>
        <Form />
      </p>
    </div>

  );
};

export default Fetch;
